// extracted by mini-css-extract-plugin
export default {"Container":"UserPageTab_Container__Q3d8p","UserPageTabTitle":"UserPageTab_UserPageTabTitle__3KL6u"};